import React from 'react';
import { LotAndTenderFiltersProvider } from './Provider';
import MainInput from './MainInput';
import { SelectedFiltersT } from './types';

interface RefactorProps {
  initialFilters: SelectedFiltersT;
  onApply: (filters: SelectedFiltersT) => void;
}

const LotAndTenderSearchFiltersRefactor: React.FC<RefactorProps> = ({
  initialFilters,
  onApply,
}) => (
  <LotAndTenderFiltersProvider
    initialFilters={initialFilters}
    onApply={onApply}
  >
    <MainInput />
  </LotAndTenderFiltersProvider>
);

export default LotAndTenderSearchFiltersRefactor;
